export default __webpack_public_path__ + "static/media/ReferencesWater.87902690.png";